var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:['text_label_value text_size_14', {'align_center': _vm.xText.alignCenter}],style:(_vm.textItemStyle)},[_c('span',{staticClass:"label",style:(_vm.labelStyle)},[_vm._v("\n    "+_vm._s(_vm.label)+"\n  ")]),_c('span',{staticClass:"value",style:(_vm.valueStyle)},[_vm._t("default")],2)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1b4cee18","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"preserveWhitespace":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/x-text/x-text-item.vue
// module id = null
// module chunks = 